export default __webpack_public_path__ + "static/media/Sunset-Edited-3840px-1176px.jpg.e03b29a1.webp";